module.exports = __webpack_public_path__ + "img/slide19.099b0ed6.jpg";